/**
 * Canonical toggle button for dropdown chevrons across the design system.
 *
 * This is the single source of truth for the circular icon-button used to
 * open/close dropdowns.  All dropdown triggers must derive from this base.
 *
 * Visual spec:
 * - 28 × 28 px, fully circular (`border-radius: 50%`)
 * - Transparent at rest, subtle neutral grey on hover via `surface.hover`
 * - Inherits `currentColor` for the icon
 */
import styled from "@emotion/styled";
import { text, surface, focusRing } from "@atlas-int/tokens";

const DropdownToggleButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  color: ${text.primary};
  flex-shrink: 0;
  appearance: none;

  &:hover {
    background-color: ${surface.hover};
  }

  &:focus-visible {
    outline: ${focusRing.width} ${focusRing.style} ${focusRing.color};
    outline-offset: ${focusRing.offset};
  }
`;

export default DropdownToggleButton;
